import React, { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { Label } from '../ui/label'
import { getDeporteHabilidades } from '../../lib/supabase'

const HabilidadesSelector = ({
  deportes = [],
  selectedIds = [],
  onChange
}) => {
  const [habilidades, setHabilidades] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!deportes.length) {
        setHabilidades([])
        return
      }
      setLoading(true)
      const todas = []
      const vistos = new Set()
      for (const deporte of deportes) {
        const { data } = await getDeporteHabilidades(deporte)
        for (const hab of data || []) {
          const key = `${hab.nombre.toLowerCase()}`
          if (!vistos.has(key)) {
            vistos.add(key)
            todas.push(hab)
          }
        }
      }
      if (!cancelled) {
        setHabilidades(todas)
        setLoading(false)
      }
    }
    load()
    return () => { cancelled = true }
  }, [deportes.join('|')])

  const toggle = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((s) => s !== id))
    } else {
      onChange([...selectedIds, id])
    }
  }

  if (!deportes.length) {
    return (
      <div>
        <Label>Habilidades</Label>
        <p className="mt-1 text-xs text-muted-foreground">
          Selecciona un deporte primero para ver las habilidades disponibles.
        </p>
      </div>
    )
  }

  return (
    <div>
      <Label>Habilidades</Label>
      {loading ? (
        <div className="flex items-center gap-2 py-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          Cargando habilidades...
        </div>
      ) : habilidades.length === 0 ? (
        <p className="mt-1 text-xs text-muted-foreground">
          No hay habilidades configuradas para los deportes seleccionados. Configura el catalogo en Configuracion &gt; Habilidades por deporte.
        </p>
      ) : (
        <div className="mt-2 flex flex-wrap gap-2">
          {habilidades.map((hab) => {
            const isSelected = selectedIds.includes(hab.id)
            return (
              <button
                key={hab.id}
                type="button"
                onClick={() => toggle(hab.id)}
                className={`rounded-full border px-3 py-1 text-xs transition-colors ${
                  isSelected
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-border text-muted-foreground hover:bg-muted/50'
                }`}
              >
                {hab.nombre}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default HabilidadesSelector
